<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        {{ dialogTitle }}
        <v-spacer />
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-text-field
          v-model="title"
          label="Tên lớp"
          placeholder="Tên lớp"
          clearable
          flat
          outlined
          dense
          hide-details
        />
        <v-text-field
          v-model="limit"
          label="Giới hạn sĩ số"
          placeholder="Giới hạn sĩ số"
          clearable
          flat
          outlined
          dense
          hide-details
          class="mt-3"
        />
        <v-select
          :items="[
            {title: 'Khối 6', value: 'Khối 6'},
            {title: 'Khối 10', value: 'Khối 10'},
          ]"
          item-text="title"
          item-value="value"
          v-model="type"
          placeholder="Khối"
          clearable
          outlined
          dense
          hide-details
          class="mt-3"
          :disabled="disabledTypeFilter"
        />
        <v-select
          :items="[
            {title: 'Cơ sở A', value: 'Cơ sở A'},
            {title: 'Cơ sở 1', value: 'Cơ sở 1'},
          ]"
          item-text="title"
          item-value="value"
          v-model="department"
          placeholder="Cơ sở"
          :disabled="disabledDepartmentFilter"
          clearable
          outlined
          dense
          hide-details
          class="mt-3"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="closeDialog">Huỷ</v-btn>
        <v-btn color="admin" class="white--text" @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
export default {
  data: () => ({
    dialog: false,
    loading: false,
    item: null,
    isEdit: false,
    id: '',
    title: '',
    limit: '40',
    type: '',
    department: '',
    disabledDepartmentFilter: true,
    disabledTypeFilter: true,
  }),
  computed: {
    ...mapGetters({user: 'auth/user'}),
    dialogTitle() {
      return this.isEdit ? 'Cập nhật lớp' : 'Tạo mới lớp'
    },
  },
  methods: {
    ...mapActions({
      checkDuplicate: 'enrollClass/countIndependent',
      createItem: 'enrollClass/createItem',
      updateItem: 'enrollClass/updateItem',
    }),
    openDialog(item = {}) {
      this.title = get(item, 'title', '')
      this.isEdit = get(item, 'isEdit', false)
      this.limit = get(item, 'limit', '')
      this.id = get(item, 'id', '')
      this.item = item
      this.type = get(item, 'type', '')
      this.department = get(item, 'department', '')
      if (this.user.department === 'both') {
        if (!item.id) this.disabledDepartmentFilter = false
      } else {
        this.department = this.user.department
      }
      if (!item.id) {
        this.disabledDepartmentFilter = false
        this.disabledTypeFilter = false
      }
      this.dialog = true
    },
    closeDialog() {
      this.reset()
      this.dialog = false
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async validateTitle() {
      const title = this.title
      if (typeof title === 'string' && title.length) {
        if (!this.isEdit) {
          const isExisted = await this.checkDuplicate({title})
          if (isExisted) return 'Tên lớp đã tồn tại, vui lòng chọn tên lớp khác'
          return ''
        }
      }
      return 'Vui lòng nhập tên lớp'
    },
    validateType() {
      const type = this.type
      if (typeof type === 'string' && type.length) return ''
      return 'Vui lòng nhập khối'
    },
    validateDepartment() {
      const department = this.department
      if (typeof department === 'string' && department.length) return ''
      return 'Vui lòng nhập cơ sở'
    },
    async validate() {
      let res = await this.validateTitle()
      if (!res.length) {
        res = this.validateType()
        if (!res.length) {
          res = this.validateDepartment()
        }
      }
      return res
    },
    async onSubmit() {
      const errMsg = await this.validate()
      if (errMsg.length) return this.$alert.error(errMsg)
      try {
        this.loading = true
        if (!this.isEdit) {
          await this.createItem({title: this.title, limit: this.limit, type: this.type, department: this.department})
          this.$alert.success('Tạo lớp mới thành công')
        } else {
          await this.updateItem({id: this.id, title: this.title, limit: this.limit})
        }
        this.$emit('onRefresh')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>